/** Keep in sync with server/helpers/flow-block-id-remap.js */

/** Map a block id through copy/import id remapping. */
export function mapFlowBlockId(idMap, value) {
  if (typeof value !== 'string' || value === '') {
    return value;
  }
  return idMap[value] ?? value;
}

const DIRECT_BLOCK_REF_KEYS = [
  'next',
  'nextOnTrue',
  'nextOnFalse',
  'nextOnNoEmail',
  'nextOnNoClient',
  'next_secondary',
  'nextOnFallback',
  'nextOnSuccess',
  'nextOnFail',
];

/** Rewrite block-to-block references inside a block's persisted `data` object. */
export function remapBlockDataReferences(data, idMap) {
  if (!data || !idMap) {
    return;
  }

  DIRECT_BLOCK_REF_KEYS.forEach((key) => {
    if (data[key]) {
      data[key] = mapFlowBlockId(idMap, data[key]);
    }
  });

  if (data.options) {
    Object.keys(data.options).forEach((optionKey) => {
      const option = data.options[optionKey];
      if (option?.next) {
        option.next = mapFlowBlockId(idMap, option.next);
      }
    });
  }

  if (data.decisions) {
    Object.keys(data.decisions).forEach((decisionKey) => {
      const decision = data.decisions[decisionKey];
      if (decision && typeof decision.next === 'string') {
        decision.next = mapFlowBlockId(idMap, decision.next);
      }
    });
  }

  if (data.routes) {
    Object.keys(data.routes).forEach((routeKey) => {
      const route = data.routes[routeKey];
      if (route && typeof route.next === 'string') {
        route.next = mapFlowBlockId(idMap, route.next);
      }
    });
  }

  if (data.reviews) {
    Object.keys(data.reviews).forEach((reviewKey) => {
      const element = data.reviews[reviewKey]?.element;
      if (!element) {
        return;
      }
      ['id', 'value', 'content'].forEach((field) => {
        if (element[field]) {
          element[field] = mapFlowBlockId(idMap, element[field]);
        }
      });
    });
  }
}

/** Rewrite references on a React Flow node/edge object used in the builder. */
export function remapFlowCanvasObject(obj, idMap) {
  if (!obj || !idMap) {
    return;
  }
  if (obj.data) {
    remapBlockDataReferences(obj.data, idMap);
  }
  if (obj.source) {
    obj.source = mapFlowBlockId(idMap, obj.source);
  }
  if (obj.target) {
    obj.target = mapFlowBlockId(idMap, obj.target);
  }
}

export function remapStartBlockId(startId, idMap) {
  if (startId == null || startId === '' || !idMap) {
    return null;
  }
  const key = String(startId);
  return idMap[key] || null;
}
